import { Route, Routes } from "react-router-dom";
import Page404 from '../pages/NotFound';
import Home from '../pages/Home/Home'


function RoutesApp() {
    return(
        <Routes>
            <Route path='/'exact element={<Home /> }/>
            <Route path="*" element={ <Page404/> }/>
        </Routes>
    )
}

export default RoutesApp